var map = {
	"./angry/initial.png": "2a24",
	"./cry/initial.png": "af59",
	"./cuteSad/initial.png": "0a0f",
	"./fun/initial.png": "0c09",
	"./kiss/initial.png": "6df9e",
	"./lol/initial.png": "174b",
	"./lolCry/initial.png": "e366",
	"./love/initial.png": "f7ae",
	"./lovely/initial.png": "009b",
	"./nerd/initial.png": "584a",
	"./no/initial.png": "bdc4",
	"./sleep/initial.png": "2ab5",
	"./winking/initial.png": "f341",
	"./wow/initial.png": "f2c3",
	"./wuaa/initial.png": "0f83",
	"./yeah/initial.png": "992e",
	"./yes/initial.png": "0ff6"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2795";